module.exports = __webpack_public_path__ + "static/img/solution01.4fc50a4b.webp";